export var GVCInternalWebSocketEvent;
(function (GVCInternalWebSocketEvent) {
    GVCInternalWebSocketEvent["WebSocketConnectionStateChange"] = "webSocketConnectionStateChange";
})(GVCInternalWebSocketEvent || (GVCInternalWebSocketEvent = {}));
export var WebSocketConnectionState;
(function (WebSocketConnectionState) {
    WebSocketConnectionState["Connected"] = "Connected";
    WebSocketConnectionState["Disconnected"] = "Disconnected";
})(WebSocketConnectionState || (WebSocketConnectionState = {}));
export var WebSocketDisconnectReason;
(function (WebSocketDisconnectReason) {
    WebSocketDisconnectReason["AuthFailure"] = "AuthFailure";
    WebSocketDisconnectReason["ClientInitiatedDisconnected"] = "ClientInitiatedDisconnected";
    WebSocketDisconnectReason["Timeout"] = "Timeout";
    WebSocketDisconnectReason["ServerInitiatedDisconnected"] = "ServerInitiatedDisconnected";
    WebSocketDisconnectReason["TransportError"] = "TransportError";
    WebSocketDisconnectReason["WebSocketError"] = "WebSocketError";
    WebSocketDisconnectReason["Unknown"] = "Unknown";
})(WebSocketDisconnectReason || (WebSocketDisconnectReason = {}));
//# sourceMappingURL=WebSocketEvents.js.map